"use client";

import Image from "next/image";
import { motion } from "framer-motion";
import { useTranslations } from "next-intl";

const CLIENTS = [
  { name: "Ayushman Hospital", logo: "/assets/clients/Ayushman%20Hospital%20[Vectorized].svg" },
  { name: "Divya Hospital", logo: "/assets/clients/Divya%20Hospital%20Logo%20[Vectorized].svg" },
  { name: "Shri Ram Hospital", logo: "/assets/clients/Shri%20Ram%20Hospital%20[Vectorized].svg" },
  { name: "Ashish Hospital", logo: "/assets/clients/ashishhospital%202%20[Vectorized].svg" },
  { name: "Asian Cancer Hospital", logo: "/assets/clients/asiancancerhospital.svg" },
  { name: "Goyal Eye Hospital", logo: "/assets/clients/goyaleyehospital%20[Vectorized].svg" },
  { name: "Sant Eknath Hospital", logo: "/assets/clients/santeknathhospital%20[Vectorized].svg" },
  { name: "The Urmil Chest Hospital", logo: "/assets/clients/theurmilchesthospital%20[Vectorized].svg" },
  { name: "Goyal Ortho & General Hospital", logo: "/assets/clients/goyalorthogeneralhospital%20[Vectorized].svg" },
  { name: "Janta Care", logo: "/assets/clients/jantacarelogo%20[Vectorized].svg" },
  { name: "Lifeline Hospital", logo: "/assets/clients/Lifelinehospitallogo%20[Vectorized].svg" },
];

export function Clients() {
  const t = useTranslations("home");

  return (
    <section className="clients-section reveal">
      <div className="container">
        <div className="clients-container">
          <div className="clients-head">
            <h2>{t("clientsTitle")}</h2>
            <div className="clients-divider" />
          </div>
          <div className="clients-fade-left" />
          <div className="clients-fade-right" />
          <div className="clients-track-wrapper">
            <div className="clients-track">
              {[...CLIENTS, ...CLIENTS, ...CLIENTS].map((client, idx) => (
                <div key={`${client.name}-${idx}`} className="client-item">
                  <div className="client-image-wrapper">
                    <Image
                      src={client.logo}
                      alt={client.name}
                      fill
                      sizes="(max-width: 720px) 180px, 260px"
                      style={{ objectFit: "contain", mixBlendMode: "multiply" }}
                      className="client-image"
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
